import axios from "axios";

const apiAI = axios.create({
  baseURL:
    "https://rj4wg3aabv2sdtnxyrfco6jfii0cpqjw.lambda-url.sa-east-1.on.aws/api",
  headers: {
    // "User-Agent": "https://reanimateads.com.br",
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

export const Api = {
  Generate: async (animationInput) => {
    try {
      let bodyContent = JSON.stringify({
        animation: `${animationInput}`,
      });
      let response = await apiAI.post("/generate", bodyContent);
      return response.data.animation;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  Copilot: async (question) => {
    try {
      let response = await apiAI.post("/chat/mastermotion", question);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  TextToSpeech: async (text) => {
    try {
      let response = await apiAI.post("/textToSpeech", text);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  TextToSpeechGetVoices: async (text) => {
    try {
      let response = await apiAI.get("/getVoices");
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
};
